module.exports = __webpack_public_path__ + "static/media/rank_icon.e19ab043.svg";